import { Box, Button, Radio } from '@capitalise/ui-design-system';
import { useCreditLimitContext } from '../../../hooks/useCreditLimitContext';

const MORE_THAN_50_TEXT =
  "If you'd like more than 50 clients speak to our team who can arrange a discounted plan.";

const TopUp = () => {
  const {
    handleContinueToOrderButton,
    maxMonitorClients,
    selectedClientsAmount,
    setSelectedClientsAmount,
    topUpVariants,
    totalClientsCount,
  } = useCreditLimitContext();
  const renderRadioButton = (clientsNumber, price) => {
    const isSelected = clientsNumber === selectedClientsAmount;
    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        p="4xsmall"
        alignItems="center"
        borderRadius="xtiny"
        backgroundColor={isSelected ? 'green-50' : 'grey-25'}
        mb="4xsmall"
        onClick={() => setSelectedClientsAmount(clientsNumber)}
        hover={{
          cursor: 'pointer',
        }}
      >
        <Box display="flex" alignItems="center">
          <Radio checked={isSelected} />
          <Box
            ml="xtiny"
            typography="body-18"
            color={isSelected ? 'green-500' : 'grey-500'}
          >{`${clientsNumber} clients`}</Box>
        </Box>
        <Box
          typography="body-18"
          color={isSelected ? 'green-500' : 'grey-500'}
        >{`${price} per month`}</Box>
      </Box>
    );
  };

  return (
    <>
      <Box typography="heading-28" mb="3xsmall">
        Choose how many clients you need
      </Box>
      <Box typography="body-16" mb="xsmall">
        {`Select the total number of clients you wish to have in Monitor. You currently have ${totalClientsCount} clients with a limit of ${maxMonitorClients} on your account.`}
      </Box>
      <Box display="flex" flexDirection="column">
        {Object.entries(topUpVariants).map(([clientsN, price]) =>
          renderRadioButton(clientsN, price),
        )}
      </Box>
      <Box typography="body-16" mb="xsmall">
        {MORE_THAN_50_TEXT}
      </Box>
      <Box width={448} position="absolute" bottom="3xsmall">
        <Button
          baseColor="green"
          disabled={selectedClientsAmount === null}
          onClick={handleContinueToOrderButton}
          fullWidth
        >
          Continue to Your order
        </Button>
      </Box>
    </>
  );
};

export default TopUp;
